import { render, staticRenderFns } from "./GraficoPizza.vue?vue&type=template&id=72543cdc&scoped=true"
import script from "./GraficoPizza.vue?vue&type=script&lang=js"
export * from "./GraficoPizza.vue?vue&type=script&lang=js"
import style0 from "./GraficoPizza.vue?vue&type=style&index=0&id=72543cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72543cdc",
  null
  
)

export default component.exports